import { useContext } from 'react'
import { Box, alpha, lighten, CssBaseline } from '@mui/material'
import { ThemeProvider, useTheme } from '@mui/material/styles'
import { Outlet } from 'react-router-dom'

import Sidebar from './Sidebar'
import Header from './Header'
import { SidebarContext } from 'src/contexts/SidebarContext'
import { MinipayGreenTheme } from 'src/theme/schemes/MinipayGreenTheme'

const PROMO_WIDTH = '440px';

// Tema fixo, exclusivo do minipay (verde + branco) — independe do tema
// escolhido pelo usuário no app principal.
const MinipaySidebarLayoutThemed = () => {
  const theme = useTheme()
  const { sidebarCollapsed } = useContext(SidebarContext)
  const isLoggedIn = !!localStorage.getItem('accessToken')

  return (
    <Box
      sx={{
        bgcolor: 'background.default',
        flex: 1,
        height: '100%',

        '.MuiPageTitle-wrapper': {
          background:
            theme.palette.mode === 'dark'
              ? theme.colors.alpha.trueWhite[5]
              : theme.colors.alpha.white[50],
          marginBottom: `${theme.spacing(4)}`,
          boxShadow:
            theme.palette.mode === 'dark'
              ? `0 1px 0 ${alpha(
                  lighten(theme.colors.primary.main, 0.7),
                  0.15
                )}, 0px 2px 4px -3px rgba(0, 0, 0, 0.2), 0px 5px 12px -4px rgba(0, 0, 0, .1)`
              : `0px 2px 4px -3px ${alpha(
                  theme.colors.alpha.black[100],
                  0.1
                )}, 0px 5px 12px -4px ${alpha(
                  theme.colors.alpha.black[100],
                  0.05
                )}`,
        },
      }}
    >
      <Header />
      <Sidebar />
      <Box
        sx={{
          position: 'relative',
          zIndex: 5,
          display: 'block',
          flex: 1,
          pt: `${theme.header.height}`,
          transition: 'margin-left 0.2s ease',
          [theme.breakpoints.up('lg')]: {
            ml: sidebarCollapsed ? 0 : isLoggedIn ? `${theme.sidebar.width}` : PROMO_WIDTH,
          },
        }}
      >
        <Box display="block">
          <Outlet />
        </Box>
      </Box>
    </Box>
  )
}

const MinipaySidebarLayout = () => (
  <ThemeProvider theme={MinipayGreenTheme}>
    <CssBaseline />
    <MinipaySidebarLayoutThemed />
  </ThemeProvider>
)

export default MinipaySidebarLayout
